import { Permission } from '@bookora/shared';

import type { TourDef } from './types';

/**
 * Inline, inside the booking dialog (`appointment-dialog.tsx`): the dialog is
 * focus-locked, so the tour is a card in its own flow, like the session
 * form's. Offered from the SECOND open on this device only. A blocked-time
 * booking has no patient field, and a solo clinic may have no doctor row —
 * those steps skip themselves. No claim about reminder SMS: the dialog does
 * not show one.
 */
export const APPOINTMENT_FORM_TOUR: TourDef = {
  key: 'appointment-form',
  version: 1,
  surface: 'inline',
  inlineHost: 'appointment-form',
  title: 'فرم ثبت نوبت',
  hubDescription: 'بیمار، خدمت، زمان و پزشک در فرم ثبت نوبت.',
  offer: { body: 'چند نکته برای ثبت سریع‌تر نوبت.' },
  route: { path: '/calendar', match: () => false, context: 'appointment-form' },
  requires: { all: [Permission.APPOINTMENT_CREATE] },
  autoOffer: true,
  maxSteps: 4,
  minSteps: 2,
  steps: [
    {
      id: 'patient',
      anchor: 'appointment.patient',
      title: 'اول، بیمار',
      body: (ctx) =>
        ctx.can(Permission.PATIENT_CREATE)
          ? 'بیمار رو با نام، موبایل یا شمارهٔ پرونده پیدا کنید. اگر پرونده نداره، همین‌جا با «ثبت بیمار جدید» براش پرونده بسازید.'
          : 'بیمار رو با نام، موبایل یا شمارهٔ پرونده پیدا کنید. با باز کردن فهرست، بیماران اخیر رو هم می‌بینید.',
    },
    {
      id: 'services',
      anchor: 'appointment.services',
      title: 'خدمات',
      body: 'با انتخاب خدمت، مدت نوبت خودکار مشخص می‌شه. جلسه درمان این نوبت هم بعداً با همین خدمت ثبت می‌شه.',
    },
    {
      id: 'datetime',
      anchor: 'appointment.datetime',
      title: 'تاریخ و ساعت',
      body: 'اگر این زمان با نوبت دیگری تداخل داشته باشه یا خارج از ساعت کاری باشه، اینجا هشدار می‌بینید. اگر ثبت نوبت ممکن نباشه، زمان‌های آزاد نزدیک رو هم پیشنهاد می‌دیم.',
    },
    {
      id: 'doctor',
      anchor: 'appointment.doctor',
      title: 'پزشک و اتاق',
      body: 'نوبت در ستون همین پزشک در تقویم دیده می‌شه. اتاق رو هم اگر لازم است انتخاب کنید.',
    },
  ],
};
